export const imagePreviewZoomMin = 1;
export const imagePreviewZoomMax = 3;
export const imagePreviewZoomStep = .25;

export const clampImagePreviewZoom = ( value: number ) => Math.min(
  imagePreviewZoomMax,
  Math.max( imagePreviewZoomMin, Number.isFinite( value ) ? value : imagePreviewZoomMin ),
);

export type ImagePreviewPan = {
  x: number;
  y: number;
};

export type ImagePreviewSize = {
  width: number;
  height: number;
};

export const clampImagePreviewPan = (
  pan: ImagePreviewPan,
  viewport: ImagePreviewSize,
  content: ImagePreviewSize,
): ImagePreviewPan => {
  const maxX = Math.max( 0, ( content.width - viewport.width ) / 2 );
  const maxY = Math.max( 0, ( content.height - viewport.height ) / 2 );

  return {
    x: Math.min( maxX, Math.max( -maxX, Number.isFinite( pan.x ) ? pan.x : 0 )),
    y: Math.min( maxY, Math.max( -maxY, Number.isFinite( pan.y ) ? pan.y : 0 )),
  };
};
